export default "__VITE_ASSET__d9c$evV$__"